export const AnalyticsTable = ({ data }: { data: [string, number, number][] }) => {
  return (
    <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
      <table className="min-w-full divide-y divide-gray-300">
        <thead className="bg-gray-50">
          <tr className="divide-x divide-gray-200">
            <th
              scope="col"
              className="py-3.5 pl-4 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-6"
            >
              Completed Applications
            </th>
            <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
              Count
            </th>
            <th scope="col" className="px-4 py-3.5 text-left text-sm font-semibold text-gray-900">
              My Cases
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {data.map((application, index) => (
            <tr key={index} className="divide-x divide-gray-200">
              <td className="whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6">
                {application[0]}
              </td>
              <td className="whitespace-nowrap p-4 text-sm text-gray-500">{application[1]}</td>
              <td className="whitespace-nowrap p-4 text-sm text-gray-500">{application[2]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
